
export enum RuleHelpContentType {

    DateStandardizationFormat = "date_standardization_format",

}